import { render, staticRenderFns } from "./saleMonthBaobiao.vue?vue&type=template&id=98972b1e&scoped=true"
import script from "./saleMonthBaobiao.vue?vue&type=script&lang=js"
export * from "./saleMonthBaobiao.vue?vue&type=script&lang=js"
import style0 from "./saleMonthBaobiao.vue?vue&type=style&index=0&id=98972b1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98972b1e",
  null
  
)

export default component.exports